'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var AudioPlayer = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    source: PropTypes.string.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    currentTime: PropTypes.number.isRequired,
    onTimeUpdate: PropTypes.func.isRequired,
    onProgress: PropTypes.func,
    onEnd: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired
  },

  componentDidMount() {
    var node = this.getDOMNode();

    node.addEventListener('loadedmetadata', this.handleLoadedMetadata);
    node.addEventListener('progress', this.handleProgress);
    node.addEventListener('timeupdate', this.handleTimeUpdate);
    node.addEventListener('ended', this.handleMediaEnd);
    node.addEventListener('error', this.handleError, true);

    // It is important to begin loading as soon as possible
    // so we learn about errors. Safari doesn't even emit
    // error event for the first time if we don't call load here.

    node.load();
    this.updateIsPlaying();
  },

  componentDidUpdate(prevProps) {
    if (prevProps.source !== this.props.source) {
      this.updateSource();
    }

    if (prevProps.isPlaying !== this.props.isPlaying) {
      this.updateIsPlaying();
    }

    if (this.props.currentTime !== this._lastReportedTime) {
      this.updateCurrentTime();
    }
  },

  componentWillUnmount() {
    var node = this.getDOMNode();

    node.removeEventListener('loadedmetadata', this.handleLoadedMetadata);
    node.removeEventListener('progress', this.handleProgress);
    node.removeEventListener('timeupdate', this.handleTimeUpdate);
    node.removeEventListener('ended', this.handleMediaEnd);
    node.removeEventListener('error', this.handleError, true);
  },

  render() {
    return (
      <audio preload='none'>
        <source src={this.props.source}
                type='audio/mpeg' />
      </audio>
    );
  },

  handleLoadedMetadata() {
    if (!this.isMounted()) {
      return;
    }

    this.updateCurrentTime();
  },

  handleTimeUpdate() {
    if (!this.isMounted()) {
      return;
    }

    var node = this.getDOMNode(),
        currentTime = node.currentTime,
        trackDuration = node.duration;

    this._lastReportedTime = currentTime;
    this.props.onTimeUpdate({
      currentTime: currentTime,
      trackDuration: trackDuration
    });
  },

  handleMediaEnd() {
    if (!this.isMounted()) {
      return;
    }

    this.getDOMNode().currentTime = 0;
    this.props.onEnd();
  },

  handleProgress() {
    if (!this.isMounted()) {
      return;
    }

    if (!this.props.onProgress) {
      return;
    }

    var node = this.getDOMNode(),
        trackDuration = node.duration,
        buffered = node.buffered;

    this.props.onProgress({
      trackDuration: trackDuration,
      buffered: buffered
    });
  },

  handleError() {
    if (!this.isMounted()) {
      return;
    }

    this.props.onError();
  },

  updateCurrentTime() {
    var node = this.getDOMNode();
    if (node.readyState) {
      node.currentTime = this.props.currentTime;
    }
  },

  updateIsPlaying() {
    var node = this.getDOMNode(),
        isPlaying = this.props.isPlaying;

    if (isPlaying) {
      node.play();
    } else {
      node.pause();
    }
  },

  updateSource() {
    var node = this.getDOMNode(),
        isPlaying = this.props.isPlaying;

    node.pause();
    node.load();

    if (isPlaying) {
      node.play();
    }
  }
});

module.exports = AudioPlayer;


/** WEBPACK FOOTER **
 ** ./atoms/AudioPlayer.jsx
 **/